import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class VariableOverrideMessageRecord
 * @augments BaseMessageRecord
 */
class VariableOverrideMessageRecord extends BaseMessageRecord({
  type: "variable_override",

  /** @memberof VariableOverrideMessageRecord# */
  variablesData: Immutable.List(),
  hasInvalidVariables: false
}) {}

/**
 * Validation
 */

/**
 * @param {VariableOverrideMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
VariableOverrideMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  message.variablesData
    .filter(data => !data.get("variableId") || !data.get("content").get("value"))
    .forEach((data, i) => invalidFields.add(`invalidVariableId-${i}`));

  if (message.hasInvalidVariables === true) {
    invalidFields.add("invalidVariableContent");
  }

  return Immutable.List(invalidFields);
};

export default VariableOverrideMessageRecord;
